export default "__VITE_ASSET__36ca3e56__"